import React, { useCallback, useState } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const TransactionDocumentProvider = ({ children }) => {
    const { data, execute, clearData, setResult } = useProviderHelpers();

    const [propertyTypes, setPropertyTypes] = useState(null);

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `TransactionDocumentSetup/GetDocumentById/${props.documentId}/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const setRecord = useCallback(async (props) => {
        await setResult({ scope: props.scope, body: props.data, payload: { status: 200, body: props.data } });
    }, [setResult]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `TransactionDocumentSetup/SaveDocumentInfo/`, method: 'POST', payload: props.data, secure: true });
    }, [execute]);

    const filterRecords = useCallback(async (props) => {
        if (props.transactionTypeId) {
            await execute({ scope: 'list', url: `TransactionDocumentSetup/FilterDocumentByTransactionType/${props.franchiseId}/${props.transactionTypeId}/${props.status}`, method: 'GET', secure: true });
        } else {
            await execute({ scope: 'list', url: `TransactionDocumentSetup/GetDocumentsByFranchise/${props.franchiseId}/${props.status}?mappingCompletedOnly=${props.mappingCompletedOnly || false}`, method: 'GET', secure: true });
        }
    }, [execute]);

    const filterProspectsRecords = useCallback(async (props) => {
        if (props.documentType) {
            await execute({ scope: 'prospectslist', url: `TransactionDocumentSetup/FilterProspectDocuments/${props.franchiseId}/${props.status}/${props.documentType}`, method: 'GET', secure: true });

        } else {
            await execute({ scope: 'prospectslist', url: `TransactionDocumentSetup/FilterProspectDocuments/${props.franchiseId}/${props.status}`, method: 'GET', secure: true });
        }

    }, [execute]);

    const value = {
        selectRecord, data, clearData, newRecord, updateRecord, filterRecords, setRecord,
        filterProspectsRecords, propertyTypes, setPropertyTypes
    };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useTransactionDocumentStore = () => React.useContext(Context);
